import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestAgendaService } from 'src/app/service/rest/agenda/rest-agenda.service';
import { News } from './news.model';

@Injectable()
export class NewsService {

  private _news: News;

  constructor(private agendaRest : RestAgendaService) { }

  public get news(): News {
    return this._news;
  }
  public set news(value: News) {
    this._news = value;
  }

  createNews(news: FormData) : Observable<News> {
    return this.agendaRest.createAgendaElement(news);
  }

  updateNews(news: FormData) {
    return this.agendaRest.updateAgendaElement(news);
  }

  deleteNews(newsId : number) {
    return this.agendaRest.deleteAgendaElement(newsId);
  }
}
